import { useEffect, useState } from 'react';
import { makeRandomString, resourceAddress } from "../../utils/sharedUtilities";
import { useLocation } from 'react-router-dom';
import { Helmet } from "react-helmet-async";
import qs from 'qs';
import Footer from "./Footer";
import Header from "./Header";
import $ from 'jquery';
import rr from '../../../scripts/radresponder';

const clients = {
    cbrn: 1,
    rr: 2,
    cr: 3,
    br: 4
};

const getReferrer = (location) => {
    const queryString = qs.parse(location.search, { ignoreQueryPrefix: true });
    const returnUrl = queryString.ReturnUrl || queryString.returnUrl || '';
    const returnQs = qs.parse(returnUrl.substring(returnUrl.indexOf('?') + 1), { ignoreQueryPrefix: true})
    const clientId = returnQs?.Client_id || returnQs?.client_id || queryString.ClientId;
    
    if (!clientId || clientId.toLowerCase().includes('cbrnresponder')) {
        return clients.cbrn;
    }
    else if (clientId.toLowerCase().includes('radresponder')) {
        return clients.rr;
    }
    else if (clientId.toLowerCase().includes('chemresponder')) {
        return clients.cr;
    }
    else if (clientId.toLowerCase().includes('bioresponder')) {
        return clients.br;
    }
    else {
        return clients.cbrn;
    }
};

const getReferrerStyle = (referrer) => {
    let customStyle = `${resourceAddress}/v1/css/custom/cbrn/customizations.css`

    if (referrer === clients.br) {
        customStyle = `${resourceAddress}/v1/css/custom/br/customizations.css`
    }
    else if (referrer === clients.cr) {
        customStyle = `${resourceAddress}/v1/css/custom/cr/customizations.css`
    }
    else if (referrer === clients.rr) {
        customStyle = `${resourceAddress}/v1/css/custom/rr/customizations.css`
    }

    return <link rel="stylesheet" href={customStyle} />;
};

const getReferrerLogo = (referrer) => {
    let logoUrl = `${resourceAddress}/v1/images/custom/logos/hostspecific/cbrn/logo-with-text.svg`

    if (referrer === clients.br) {
        logoUrl = `${resourceAddress}/v1/images/custom/logos/hostspecific/br/logo-with-text.svg`
    }
    else if (referrer === clients.cr) {
        logoUrl = `${resourceAddress}/v1/images/custom/logos/hostspecific/cr/logo-with-text.svg`
    }
    else if (referrer === clients.rr) {
        logoUrl = `${resourceAddress}/v1/images/custom/logos/hostspecific/rr/logo-with-text.svg`
    }

    return <img className="logo-banner" alt="CBRN Logo" src={logoUrl} />;
};

const Layout = (props) => {
    const location = useLocation();
    const referrer = getReferrer(location);

    const [path, setPath] = useState('');

    useEffect(() => {
        (async () => {
            const data = await $.post(rr.getApiAddress() + "account/getpaths");
            switch (referrer) {
                case clients.rr:
                    setPath(data.rr);
                    break;
                case clients.cr:
                    setPath(data.cr);
                    break;
                case clients.br:
                    setPath(data.br);
                    break;
                default:
                    setPath(data.cbrn);
            }
        })();
    }, []);
    
    return (
        <>
            <Helmet>
                {getReferrerStyle(referrer)}
            </Helmet>
            <Header config={props.config} />
            <a className="skip-link sr-only sr-only-focusable" href="#loginCont">Skip Top Navigation</a>
            <div id="layout-navbar" className="navbar navbar-default navbar-fixed-top" role="navigation">
                <div className="navbar-header nowrap">
                    <a className="navbar-brand" href={path + "#home"}>
                        {getReferrerLogo(referrer)}
                    </a>

                    <button type="button" className="navbar-toggle collapsed pull-right" data-toggle="collapse" data-target="index#navbar">
                        <span className="sr-only">Toggle navigation</span>
                        <span className="icon-bar"></span>
                        <span className="icon-bar"></span>
                        <span className="icon-bar"></span>
                    </button>
                </div>

                <div className="collapse navbar-collapse" id="navbar">
                    <ul className="nav navbar-nav">
                        <li>
                            <a href={path + "#contact/index"}>
                                <i className="fa fa-solid fa-fw fa-comments"></i>
                                <span className="show-collapsed hidden-xs">&nbsp;Contact</span>
                            </a>
                        </li>
                    </ul>
                </div>

            </div>

            {props.children}

            {/*<input type="hidden" id="virtualDirectoryPath" value="@Url.Content("~")" />*/}
            {/*<input type="hidden" id="resourcesAddress" value="@string.Format("{0}{1} /", Model.Paths.ResourcesAddress, Model.Paths.ResourcesVersion)" />*/}
            {/*<input type="hidden" id="appVersion" value="@ViewBag.AppVersion" />*/}

            {/* Field to add random length to each request to mitigate BREACH attacks - Security Requirement */}
            <input type="hidden" id="compressionBuffer" value={makeRandomString()} />

            <Footer {...props} />
        </>
    );
}

export default Layout;